function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M8.706 5.48a.835.835 0 00-1.176 0 11.765 11.765 0 00-3.502 8.401v9.546c0 .456.372.826.83.826.46 0 .832-.37.832-.826v-9.546a10.13 10.13 0 013.016-7.233.822.822 0 000-1.168zM12.045 4.427a10.299 10.299 0 013.941-.775c5.678 0 10.297 4.588 10.297 10.23 0 .455.372.825.831.825.46 0 .831-.37.831-.826 0-3.174-1.244-6.157-3.502-8.401A11.92 11.92 0 0015.986 2c-1.585 0-3.125.303-4.577.902a.824.824 0 00-.45 1.079.833.833 0 001.086.446zM27.114 17.478c-.459 0-.83.37-.83.825v5.124c0 .456.371.825.83.825.46 0 .831-.37.831-.825v-5.124a.828.828 0 00-.83-.825zM9.31 22.336c-.46 0-.831.37-.831.825v4.423c0 .456.372.826.83.826.46 0 .832-.37.832-.826V23.16a.829.829 0 00-.831-.825z"
}), React.createElement("path", {
  d: "M15.986 6.422c-4.14 0-7.507 3.346-7.507 7.46v4.858c0 .455.372.825.83.825.46 0 .832-.37.832-.825V13.88c0-3.202 2.622-5.807 5.845-5.807 1.562 0 3.03.604 4.134 1.7a.835.835 0 001.175 0 .822.822 0 000-1.167 7.483 7.483 0 00-5.309-2.185zM22.663 13.055a.829.829 0 00-.83.826v13.703c0 .456.371.825.83.825.46 0 .831-.37.831-.825V13.88a.829.829 0 00-.83-.826z"
}), React.createElement("path", {
  d: "M13.761 13.055c-.46 0-.831.37-.831.826v15.293c0 .456.372.826.831.826.459 0 .831-.37.831-.826V13.881a.829.829 0 00-.831-.826z"
}), React.createElement("path", {
  d: "M15.986 10.844c-.404 0-.798.078-1.17.23a.824.824 0 00-.45 1.08.833.833 0 001.087.447 1.391 1.391 0 011.928 1.28v15.293c0 .456.372.826.83.826.46 0 .832-.37.832-.826V13.881c0-1.674-1.371-3.037-3.057-3.037z"
}));

var SvgIcNavNotRegisteredActive = function SvgIcNavNotRegisteredActive(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
};

export default __webpack_public_path__ + "653938392e61b6ae749581a24061f905.svg";
export { SvgIcNavNotRegisteredActive as ReactComponent };